const adminRoutes = [
];


export default adminRoutes;
